import Text from '../Text';

const CustomerStories = () => {
  const reviews = [
    {
      boldText: '"Enhancing Work Efficiency & Saving Time!',
      text: 'The tool operates flawlessly, effectively recognizing various contents and elements of CVs, and also generating summaries based on the document`s data. Furthermore, the ability to customize enhances the functionality of the creator. As we handle a large number of profiles daily, this tool significantly streamlines our workflow and enables us to save a substantial amount of time (averaging about 80-90%)"',
      author: 'Szymon Nowak',
      description: 'CEO of NS Code',
    },
    {
      boldText: '"A Game-Changer for Recruiting Efficiency!',
      text: `This tool is amazing for handling CVs—it quickly picks out the important stuff and sums it up nicely. I can even adjust it to work just how I need it. Since I go through lots of profiles every day, this tool really helps me work faster, saving me lots of time!"`,
      author: 'Martyna Kąciak',
      description: 'Head of HR at Happy Team',
    },
    {
      boldText: '“Elevating Recruitment Practices to New Heights!',
      text: "I've been in the recruiting field for over a decade, and anonymizing CVs was once a manual, time-consuming task, automates the process effortlessly. Also, we can tailor CVs to match specific job requirements.”",
      author: 'Hanna',
      description: 'IT Recruiter',
    },
  ];
  return (
    <div className="flex flex-col items-center bg-neutral-200 px-5 pb-20 md:px-20">
      <div>
        <div className="relative mb-16 mt-28 flex w-fit flex-col gap-5">
          <Text variant="faq" className="text-black">
            REVIEWS
          </Text>
          <Text variant="display-3" className="mb-5 text-neutral-1000">
            Customer Stories
          </Text>
          <Text
            variant="h4"
            className="absolute -bottom-5 right-0 self-end font-semibold text-neutral-700 md:-right-10"
          >
            THAT SPEAK VOLUMES
          </Text>
        </div>
        <div className="mb-32  flex flex-col items-center gap-5 py-5 md:py-10 lg:flex-row">
          {reviews.map(({ description, author, boldText, text }) => (
            <div
              key={text}
              className="flex w-full max-w-sm flex-1 flex-col justify-between rounded-[1.25rem] bg-neutral-100 p-6 shadow-review-card md:aspect-[3/4]"
            >
              <div className="flex flex-col gap-5">
                <Text className="font-semibold text-neutral-900">
                  {boldText}
                </Text>
                <Text className="text-neutral-700">{text}</Text>
              </div>
              <div className="flex flex-col">
                <Text className="font-semibold text-neutral-1000">
                  {author}
                </Text>
                <Text variant="body-small" className="text-neutral-700">
                  {description}
                </Text>
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default CustomerStories;
